/* import __COLOCATED_TEMPLATE__ from './char-counter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();